import { Pipe, PipeTransform } from '@angular/core'
import { CurrentQuoteStatus } from '../../../../../models/status/status.model'

@Pipe({
  standalone: false,
  name: 'statusFilter',
})
export class StatusFilterPipe implements PipeTransform {
  transform(value: any[], ...args: any[]): any {
    if (!value && value?.length === 0) {
      return value
    } else {
      return value.filter(
        (item) =>
          item?.quoteStatusCode === CurrentQuoteStatus.OPEN &&
          item?.isOrderCreated === false
      )
    }
  }
}
